import React from "react";
import "../assets/styles/Contact.scss";

import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import { Box, Typography, Link } from "@mui/material";

function Contact({ mode }) {
  return (
    <div id="contact" className={`contact-section ${mode}`}>
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Contact Me</h1>
          <p className="contact-intro">
            Let's build something great together. Feel free to reach out via any
            of the platforms below.
          </p>

          <Box className="contact-details">
            <Box className="contact-item">
              <EmailIcon />
              <Link
                href="mailto:contactvedant007@gmail.com"
                underline="hover"
                className={mode}
              >
                contactvedant007@gmail.com
              </Link>
            </Box>

            <Box className="contact-item">
              <PhoneIcon />
              <Typography className={mode}>+91 7284982533</Typography>
            </Box>

            <Box className="contact-item">
              <LinkedInIcon />
              <Link
                href="https://www.linkedin.com/in/vedantpatel31"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                className={mode}
              >
                linkedin.com/in/vedantpatel31
              </Link>
            </Box>

            <Box className="contact-item">
              <GitHubIcon />
              <Link
                href="https://github.com/vedantcode04"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                className={mode}
              >
                github.com/vedantcode04
              </Link>
            </Box>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default Contact;
